<template>
  <b-overlay
    opacity="0.75"
    spinner-variant="primary"
    :show="$root.$data.bsLoader"
  >
    <div class="edit-user-profile">
      <!-- navbar -->
      <nav-bar />
      <div class="user-settings">
        <!-- sidebar -->
        <div class="change-details">
          <tabs-bar></tabs-bar>
        </div>

        <!-- form -->
        <div class="user-form">
          <a href="#!" class="menu" @click="opensidebar()">
              <i class="fas fa-bars fa-2x"></i>
          </a>
          <div class="user-form-box p-4">
            <div class="card-body">
              <div class="img-wrapper">
                <div class="logo">
                  <img
                    v-if="manager_details.logo_url"
                    :src="manager_details.logo_url"
                    alt="Company Logo"
                  />
                    <div class="edit">
                        <b-link
                            v-b-tooltip.hover title="Upload Company Image"
                            href="#!" class="text-decoration-none" @click="$refs.companyLogoFileInput.click()"><i class="fas fa-edit"></i>Upload</b-link>
                        <input
                            type="file"
                            class="sr-only"
                            ref="companyLogoFileInput"
                            @change="uploadCompanyLogo"/>
                    </div>
                </div>
                <div
                  class="help-block invalid-feedback"
                  v-if="form.errors.errors.business_logo"
                >
                  {{ form.errors.errors.business_logo[0] }}
                </div>
                <!-- <img
                    v-else
                    :src="$root.serverBasePath + '/strata.png'"
                    alt="Strata Connex"
                    style="height: 40px"
                /> -->
              </div>
              <h1 class="head-title font-weight-bold text-center">
                Company Profile
              </h1>

              <b-form
                @submit.prevent="formSubmitted"
                @keydown="form.onKeydown($event)"
                class="mt-5"
              >
                <b-row>
                  <b-col cols="12" md="12">
                    <b-form-group>
                      <template v-slot:label>
                        Company Name <span class="text-danger">*</span>
                      </template>
                      <b-form-input
                        type="text"
                        v-model="form.company_name"
                      ></b-form-input>
                      <div
                        class="help-block invalid-feedback"
                        v-if="form.errors.errors.company_name"
                      >
                        {{ form.errors.errors.company_name[0] }}
                      </div>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" md="12">
                    <b-form-group label="Description">
                      <b-form-textarea
                        id="textarea"
                        v-model="form.description"
                        placeholder="Enter something..."
                        rows="3"
                        max-rows="6"
                      ></b-form-textarea>
                      <div
                        class="help-block invalid-feedback"
                        v-if="form.errors.errors.description"
                      >
                        {{ form.errors.errors.description[0] }}
                      </div>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" md="12">
                    <b-form-group label="Website">
                      <b-form-input
                        type="text"
                        v-model="form.website"
                      ></b-form-input>
                      <div
                        class="help-block invalid-feedback"
                        v-if="form.errors.errors.website"
                      >
                        {{ form.errors.errors.website[0] }}
                      </div>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" md="12">
                    <b-form-group>
                      <template v-slot:label>
                        ABN/ACN <span class="text-danger">*</span>
                      </template>
                      <b-form-input
                        type="text"
                        v-model="form.abn_acn"
                        @keyup="abnNumber"
                      ></b-form-input>
                      <div
                        class="help-block invalid-feedback"
                        v-if="form.errors.errors.abn_acn"
                      >
                        {{ form.errors.errors.abn_acn[0] }}
                      </div>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" md="12">
                    <b-form-group>
                      <template v-slot:label>
                        Business Address <span class="text-danger">*</span>
                      </template>
                      <b-form-input
                        type="text"
                        v-model="form.business_address"
                        placeholder="Street address, Suburb, State, Postal code"
                      ></b-form-input>
                      <div
                        class="help-block invalid-feedback"
                        v-if="form.errors.errors.address"
                      >
                        {{ form.errors.errors.address[0] }}
                      </div>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" md="12">
                    <b-form-group label="Mailing Address">
                      <b-form-input
                        type="text"
                        v-model="form.mail_address"
                      ></b-form-input>
                      <div
                        class="help-block invalid-feedback"
                        v-if="form.errors.errors.mail_address"
                      >
                        {{ form.errors.errors.mail_address[0] }}
                      </div>
                        <span
                        @click="copyBusinessAddress"
                        style="font-size: 11px; color: #5f2eea; cursor: pointer"
                        >Same As Business Address</span
                      >
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" md="12">
                    <b-form-group label="Billing Email">
                      <b-form-input
                        type="text"
                        v-model="form.billing_email"
                      ></b-form-input>
                      <div
                        class="help-block invalid-feedback"
                        v-if="form.errors.errors.billing_email"
                      >
                        {{ form.errors.errors.billing_email[0] }}
                      </div>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" md="12">
                    <b-form-group label="Business Mobile Phone">
                      <b-form-input
                        type="text"
                        v-model="formattedPhone"
                        @keyup="formatPhone"
                      ></b-form-input>
                      <div
                        class="help-block invalid-feedback"
                        v-if="form.errors.errors.phone"
                      >
                        {{ form.errors.errors.phone[0] }}
                      </div>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" md="12">
                    <b-form-group label="Number of Employees">
                      <b-form-select
                        type="text"
                        v-model="form.number_employees"
                        :options="employees"
                      ></b-form-select>
                      <div
                        class="help-block invalid-feedback"
                        v-if="form.errors.errors.number_employees"
                      >
                        {{ form.errors.errors.number_employees[0] }}
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-alert show variant="success" v-if="successMessage">{{
                  successMessage
                }}</b-alert>
                <b-button
                  :disabled="form.busy"
                  type="submit"
                  variant="primary"
                  class="btn-grad float-right mt-4"
                  >Save Changes</b-button
                >
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import NavBar from "../includes/NavBar.vue";
import { Form, HasError } from "vform";
import TabsBar from "../includes/TabsBar.vue";
import phoneNoMixin from "../../../../mixins/phoneNoMixin.js";
import toggleMixin from "../../../../mixins/toggleMixin.js";
import Swal from "sweetalert2";

export default {
  props: [],
  components: {
    TabsBar,
    HasError,
    NavBar,
  },
  mixins: [phoneNoMixin, toggleMixin],
  data() {
    return {
      form: new Form({
        company_name: "",
        description: "",
        website: "",
        abn_acn: "",
        business_address: "",
        phone: "",
        mail_address: "",
        billing_email: "",
        number_employees: "",
        role: "",
        business_logo: "",
      }),
      manager_details: {
        manager_email: "",
        logo_url: "",
      },
      employees: [
        { value: "", text: "Range", disabled: true },
        { value: "1-5", text: "1 - 5" },
        { value: "5-10", text: "5 - 10" },
        { value: "10-20", text: "10 - 20" },
        { value: "20-100", text: "More than 20" },
      ],
      formattedPhone: "",
      successMessage: "",
    };
  },
  mounted() {
    this.getBusinessDetails();
  },
  methods: {
    getBusinessDetails() {
      this.$root.$data.bsLoader = true;
      this.form
        .post("api/manager/get-business-details")
        .then((response) => {
          this.form.fill(response.data.business_details);
          if (response.data.business_details?.phone) {
            this.formattedPhone = this.formatPhoneForAustralia(
              response.data.business_details.phone
            );
          }
          this.manager_details.logo_url = response.data.logo_url
            ? response.data.logo_url
            : this.$root.serverBasePath + "/log.png";
          this.manager_details.manager_email = response.data.manager_email;
          this.form.role = "manager";

          this.$root.$data.bsLoader = false;
        })
        .catch((err) => {
          this.$root.$data.bsLoader = false;
        });
    },
    formSubmitted() {
      this.$root.$data.bsLoader = true;
      var data = new FormData();
      data.append("company_name", this.form.company_name);
      data.append("description", this.form.description);
      data.append("website", this.form.website);
      data.append("abn_acn", this.form.abn_acn);
      data.append("address", this.form.business_address);
      data.append("phone", this.form.phone);
      data.append("mail_address", this.form.mail_address);
      data.append("billing_email", this.form.billing_email);
      data.append("number_employees", this.form.number_employees);

      if(this.form.business_logo instanceof File){
        data.append("business_logo", this.form.business_logo);
      }

      axios
        .post("api/manager/update-business-details", data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
           this.getBusinessDetails();
          Swal.fire({
            title: "Business Details Updated Successfully.",
            icon: "success",
            timer: 3000,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
          });
          this.$root.$data.bsLoader = false;
        })
        .catch((error) => {
          this.form.errors = error.response.data;
          this.$root.$data.bsLoader = false;
        });
    },
    uploadCompanyLogo(event) {
      if (!event.target.files.length) return;
      var document = event.target.files[0];
      this.form.business_logo = document;
      if (!event.target.files.length) return;

      let formData = new FormData();
      formData.append("logo", event.target.files[0]);

      axios
        .post("api/manager/upload-business-logo", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          this.manager_details.logo_url = response.data.logo_url;
        });
    },
    abnNumber() {
      this.form.abn_acn = this.getABNACNDigitsOnly(this.form.abn_acn);
    },
    formatPhone() {
      this.form.phone = this.getPhoneDigitsOnly(this.formattedPhone);
      this.formattedPhone = this.formatPhoneForAustralia(this.form.phone);
    },
    opensidebar() {
      let sidebarDetails = document.querySelector(".change-details");
      this.toggleProfile(sidebarDetails);
    },
     copyBusinessAddress() {
      this.form.mail_address = this.form.business_address;
    },
  },
};
</script>
